import { component, prop } from '../../../decorators';

import SvgComponentMixin from '../../../mixins/svg.component.mixin';
import PeriodScaleMixin from '../../../mixins/period.scale.mixin';

@component({
   mixins: [ SvgComponentMixin, PeriodScaleMixin ]
})
export default class Flow {
   @prop({ type: String, required: true }) type
   @prop({ type: Array, required: true }) info
   @prop({ type: Number, required: true }) duration
   @prop({ type: Object }) currentItem

   get preparedItems() {
      return this.info.map(line => {
         return line.map(item => {
            const { id, name, synopsis, thumbnailUrl, tcIn, tcOut } = item;
            const left = this.x(tcIn);
            const right = this.x(tcOut);
            const width = right - left;
            return { id, name: isClip(item) ? synopsis : name, thumbnailUrl, left, right, width, item };
         });
      });
   }

   x(tc) {
      const { minExtent, maxExtent, width } = this;
      return width * ( tc - minExtent ) / ( maxExtent - minExtent );
   }

   onItemClick({ item }) {
      this.$emit('select', { type: this.type, item });
   }
   onItemDblClick({ item }) {
      this.$emit('open-info', { type: this.type, item });
   }
   onFlowClick() {
      this.$emit('select', { type: this.type, item: null });
   }

   label({item}) {
      const { metadataType, name, talentName, synopsis } = item;
      if ( metadataType === 'character' && talentName ) {
         return `${name} (${talentName})`;
      }
      return name || synopsis;
   }
}

function isClip(item) {
   return !item.metadataType;
}
